/**
 * Constants
 */

/* eslint-disable max-len */

const ROUTES = {
  // Auth routes
  DIGITAL_EVENT_AUTH: "digital-event-auth",
  DIGITAL_EVENT_AUTH_LOGIN: "digital-event-auth-login",
  DIGITAL_EVENT_AUTH_LOGOUT: "digital-event-auth-logout",
  DIGITAL_EVENT_AUTH_CREATE_ACCOUNT: "digital-event-auth-create-account",
  DIGITAL_EVENT_AUTH_CONFIRM_ACCOUNT: "digital-event-auth-confirm-account",
  DIGITAL_EVENT_AUTH_SET_PASSWORD: "digital-event-auth-set-password",
  DIGITAL_EVENT_AUTH_SET_NEW_PASSWORD: "digital-event-auth-set-new-password",
  DIGITAL_EVENT_AUTH_RESET_TEMP_PASSWORD: "digital-event-auth-reset-temp-password",
  DIGITAL_EVENT_AUTH_CONFIRM_NEW_PASSWORD: "digital-event-auth-confirm-new-password",
  DIGITAL_EVENT_AUTH_TABLE_INFO: "digital-event-auth-table-info",

  // Room routes
  DIGITAL_EVENT_ROOM_LIST: "digital-event-room-list",
  DIGITAL_EVENT_ROOM: "digital-event-room"
};

const USER_STATUSES = {
  ACTIVE: "Active"
};

const CONTENT_TYPE_SLUGS = {
  DIGITAL_EVENT: "DigitalEvent",
  DIGITAL_EVENT_ROOM: "DigitalEventRoom",
  DIGITAL_EVENT_TABLE: "DigitalEventTable",
  SPONSOR_PROFILE_LIST: "SponsorProfileList"
};

const TABLE_TYPES = {
  VIRTUAL_GUESTS: "VirtualGuests",
  PUBLIC_GALLERY: "PublicGallery",
  SPONSOR: "Sponsor",
  VIP: "VIP",
  IN_PERSON_GUESTS: "InPersonGuests"
};

const ASSIGNMENT_TYPES = {
  DOMAIN: "Domain",
  EMAIL: "Email"
};

const GROUP_TYPES = {
  EVENT: "EVENT",
  ROOM: "ROOM",
  TABLE: "TABLE"
};

const MESSAGE_TYPES = {
  ANNOUNCEMENT: "ANNOUNCEMENT",
  MESSAGE: "MESSAGE",
  BANNER: "BANNER"
};

const MESSAGE_STATUS = {
  PUBLISHED: "PUBLISHED",
  DRAFT: "DRAFT",
  HIDDEN: "HIDDEN",
  DELETED: "DELETED"
};

const EVESSIO_DOMAINS = ["evessio.com"];

const PASSWORD_VALIDATION = {
  REGEXP: /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])[0-9a-zA-Z\-!@£$%^&*?()_+=.><#]{8,}$/,
  ERROR_MESSAGE: "Minimum eight characters, at least one uppercase letter, one lowercase letter, one number"
};

const EMAIL_REGEXP = /^[^@]+@[^@]+\.[^@]+$/;

const SYSTEM_HEADERS = {
  ANNOUNCE: "<h4><i class='fa fa-fw fa-bullhorn'></i>&nbsp;Announcement</h4>",
  TABLE_MOVEMENT_INVITE: "<h4><i class='fa fa-fw fa-user-plus'></i>&nbsp;Move {} Invitation</h4>",
  VIDEO_CALL_INVITE: "<h4><i class='fa fa-fw fa-video-camera'></i>&nbsp;Video chat request</h4>",
  VIDEO_CALL: "<h4><i class='fa fa-fw fa-video-camera'></i>&nbsp;Video chat</h4>"
};

const SYSTEM_MESSAGES = {
  TABLE_MOVEMENT_INVITE:
    "<p><b>{}</b> has invited you to join them on their {} - <b>{}</b>.</p>" +
    "<p>If you accept you will be moved from your current {}.</p>",
  USER_MOVEMENT_INVITE_DECLINE: "<b>{}</b> is unable to join your {}.",
  USER_MOVEMENT_INVITE_ACCEPT: "<b>{}</b> accepted your invitation and has joined your {}.",
  USER_MOVEMENT_INVITE_LEFT_TABLE: "<b>{}</b> has left the {}.",
  USER_MOVEMENT_INVITE_JOINED_TABLE: "<b>{}</b> has joined the {} after accepting an invite from <b>{}</b>",

  VIDEO_CALL_INVITE: "<p>You have received a request for video chat from <b>{} / {}</b>",
  VIDEO_CALL_INVITE_DECLINE_BY_INVITEE: "Call declined by <b>{}</b>",
  VIDEO_CALL_INVITE_DECLINE_BY_ACCEPTING_ANOTHER_CALL: "<b>{}</b> is currently engaged on another call",
  VIDEO_CALL_INVITE_DECLINE_BY_INVITER: "Call declined by <b>{}</b>",
  VIDEO_CALL_INVITE_DECLINE_BY_TIMEOUT: "<b>{}</b> is not available",
  ONE_TO_ONE_VIDEO_CALL_ENDED: "Call with <b>{}</b> ended (duration: {})",
  LEAVE_GROUP_VIDEO_CALL: "<b>{}</b> has left the conversation",

  MOVED_BY_EA: "<b>{}</b> has been moved to the {} by Event Admin"
};

const INVITE_TYPES = {
  TABLE_MOVEMENT: "TABLE_MOVEMENT",
  VIDEO_CALL: "VIDEO_CALL"
};

const INVITE_STATUSES = {
  SEND: "SEND",
  ACCEPT: "ACCEPT",
  DECLINE_BY_INVITEE: "DECLINE_BY_INVITEE",
  DECLINE_BY_ACCEPTING_ANOTHER_CALL: "DECLINE_BY_ACCEPTING_ANOTHER_CALL",
  DECLINE_BY_INVITER: "DECLINE_BY_INVITER",
  DECLINE_BY_TIMEOUT: "DECLINE_BY_TIMEOUT"
};

const INVITE_CREATION_STATUSES = {
  IN_PROCESS: "IN_PROCESS",
  CREATED: "CREATED"
};

const WSS_MESSAGE_TYPES = {
  SYSTEM: "system",
  PING: "ping",
  REACTION: "reaction",

  UPDATE_DIGITAL_EVENT: "updateDigitalEvent",
  UPDATE_DIGITAL_EVENT_ROOM: "updateDigitalEventRoom",
  ADD_DIGITAL_EVENT_TABLE: "addDigitalEventTable",
  UPDATE_DIGITAL_EVENT_TABLE: "updateDigitalEventTable",
  DELETE_DIGITAL_EVENT_TABLE: "deleteDigitalEventTable",
  MERGE_ASSIGNMENTS: "mergeAssignments",

  ANNOUNCE_MESSAGE: "announceMessage",
  BANNER_MESSAGE: "bannerMessage",
  ROOM_MESSAGE: "roomMessage",
  TABLE_MESSAGE: "tableMessage",
  PRIVATE_MESSAGE: "privateMessage",
  TABLE_CREATION: "tableCreation",
  UPDATE_MESSAGE: "updateMessage",

  INVITE: "invite",

  CHANGE_ROOM: "changeRoom",

  PHOTOWALL_CREATE_POST: "photowallCreatePost",
  PHOTOWALL_UPDATE_POST: "photowallUpdatePost",
  PHOTOWALL_DELETE_POST: "photowallDeletePost"
};

const WSS_ACTION_TYPES = {
  VIDEO_CHAT_UPDATED: "VIDEO_CHAT_UPDATED",
  ONE_TO_ONE_VIDEO_CALL_ENDED: "ONE_TO_ONE_VIDEO_CALL_ENDED",
  JOIN_GROUP_VIDEO_CALL: "JOIN_GROUP_VIDEO_CALL",
  LEAVE_GROUP_VIDEO_CALL: "LEAVE_GROUP_VIDEO_CALL"
};

const VIDEO_SESSION_SIGNAL_TYPES = {
  JOIN_GROUP_VIDEO_CALL: "JOIN_GROUP_VIDEO_CALL",
  LEAVE_GROUP_VIDEO_CALL: "LEAVE_GROUP_VIDEO_CALL"
};

const CHAT_MODES = {
  ROOM: "ROOM",
  TABLE: "TABLE",
  PRIVATE: "PRIVATE",
  PROFILE: "PROFILE"
};

const ANNOUNCEMENT_TYPES = {
  BANNER: "BANNER",
  CELEBRATION: "CELEBRATION",
  TABLE_MOVEMENT_INVITE_SEND: "TABLE_MOVEMENT_INVITE_SEND",
  TABLE_MOVEMENT_INVITE_ACCEPT: "TABLE_MOVEMENT_INVITE_ACCEPT",
  TABLE_MOVEMENT_INVITE_DECLINE: "TABLE_MOVEMENT_INVITE_DECLINE",
  VIDEO_CALL_INVITE_SEND: "VIDEO_CALL_INVITE_SEND",
  VIDEO_CALL_INVITE_ACCEPT: "VIDEO_CALL_INVITE_ACCEPT",
  VIDEO_CALL_INVITE_DECLINE: "VIDEO_CALL_INVITE_DECLINE",
  ONE_TO_ONE_VIDEO_CALL_ENDED: "ONE_TO_ONE_VIDEO_CALL_ENDED",
  LEAVE_GROUP_VIDEO_CALL: "LEAVE_GROUP_VIDEO_CALL"
};

const MEDIA_DEVICE_STATUSES = {
  DENY: 0,
  AUDIO_ALLOW: 1,
  VIDEO_ALLOW: 2,
  ALLOW: 3,
  BUSY: 4
};

const VIDEO_CHAT_STATUSES = {
  ACTIVE: "ACTIVE",
  INACTIVE: "INACTIVE"
};

const VIDEO_CHAT_TYPES = {
  ONE_TO_ONE: "ONE_TO_ONE",
  MANY_TO_MANY: "MANY_TO_MANY"
};

const VIDEO_MEMBER_TYPES = {
  SELF: "SELF",
  PUBLISHER: "PUBLISHER",
  SUBSCRIBER: "SUBSCRIBER",
  INVITEE: "INVITEE"
};

const VIDEO_MEMBER_ROLES = {
  MODERATOR: "moderator",
  PUBLISHER: "publisher",
  SUBSCRIBER: "subscriber"
};

const DECLINE_INVITE_ANNOUNCE_MAP = (() => {
  let declineInviteAnnounceMap = {};
  declineInviteAnnounceMap[INVITE_TYPES.TABLE_MOVEMENT] = ANNOUNCEMENT_TYPES.TABLE_MOVEMENT_INVITE_DECLINE;
  declineInviteAnnounceMap[INVITE_TYPES.VIDEO_CALL] = ANNOUNCEMENT_TYPES.VIDEO_CALL_INVITE_DECLINE;
  return declineInviteAnnounceMap;
})();

/*eslint max-len: ["error", { "ignoreComments": true }]*/
const MAXIMUM_VIDEO_CHAT_MEMBERS = 50; // https://support.tokbox.com/hc/en-us/articles/360029413432-How-many-participants-are-supported-in-a-session-#:~:text=For%20multi%2Dparty%20video%20session,to%2050%20to%2055%20participants.

const USER_CONNECTIONS_STATUSES = {
  INACTIVE: "0",
  ACTIVE: "1",
  DELETED: "2"
};

const NOTIFICATION_TYPES = {
  SUCCESS: "success",
  WARNING: "warning",
  INFO: "info",
  ERROR: "error",
  OFFLINE: "offline"
};

const DISALLOWED_BROWSERS = {
  OPR: "Opera",
  TRIDENT: "Microsoft Internet Explorer"
};

const FIXED_SIZE_FORMATS = ["svg+xml", "x-icon", "vnd.microsoft.icon"];
const IMAGE_EXTENSIONS = ["png", "jpeg", "jpg", "gif", "svg", "ico", "heif", "heic", "webp"];
const PHOTO_WALL_EXTENSIONS = ["png", "jpeg", "jpg", "gif", "heif", "heic", "webp"];
const MAX_IMAGE_SIZE_MB = 40;
const TIMEOUTS = [3, 5, 8, 10, 15, 20];

const MESSAGE_STATUSES = {
  HIDDEN: "HIDDEN",
  PUBLISHED: "PUBLISHED",
  DRAFT: "DRAFT",
  DELETED: "DELETED"
};

const ANNOUNCEMENT_TYPES_DATA = [
  {
    title: "Banner announcement",
    subtitle: "Message is contained in an orange banner",
    value: ANNOUNCEMENT_TYPES.BANNER,
    messageType: "announceMessage"
  },
  {
    title: "Celebration: confetti",
    subtitle: "Message is placed in the centre of the screen surrounded by confetti",
    value: ANNOUNCEMENT_TYPES.CELEBRATION,
    messageType: "bannerMessage"
  }
];

const SPONSOR_SLIDER_POSITION = {
  BELOW_SPONSOR_GR: 4,
  ABOVE_SPONSOR_GR: 2,
  ABOVE_PHOTO_WALL: 0
};
const ROOMS_NAVIGATION_STYLE = {
  BUTTONS: "buttons",
  DROPDOWN: "dropdown"
};

export {
  ROUTES,
  USER_STATUSES,
  CONTENT_TYPE_SLUGS,
  TABLE_TYPES,
  ASSIGNMENT_TYPES,
  GROUP_TYPES,
  MESSAGE_TYPES,
  MESSAGE_STATUS,
  EVESSIO_DOMAINS,
  PASSWORD_VALIDATION,
  EMAIL_REGEXP,
  SYSTEM_MESSAGES,
  SYSTEM_HEADERS,
  INVITE_TYPES,
  INVITE_STATUSES,
  INVITE_CREATION_STATUSES,
  WSS_MESSAGE_TYPES,
  WSS_ACTION_TYPES,
  VIDEO_SESSION_SIGNAL_TYPES,
  CHAT_MODES,
  ANNOUNCEMENT_TYPES,
  ANNOUNCEMENT_TYPES_DATA,
  MEDIA_DEVICE_STATUSES,
  VIDEO_CHAT_STATUSES,
  VIDEO_CHAT_TYPES,
  VIDEO_MEMBER_TYPES,
  VIDEO_MEMBER_ROLES,
  DECLINE_INVITE_ANNOUNCE_MAP,
  MAXIMUM_VIDEO_CHAT_MEMBERS,
  USER_CONNECTIONS_STATUSES,
  DISALLOWED_BROWSERS,
  NOTIFICATION_TYPES,
  IMAGE_EXTENSIONS,
  FIXED_SIZE_FORMATS,
  MESSAGE_STATUSES,
  MAX_IMAGE_SIZE_MB,
  PHOTO_WALL_EXTENSIONS,
  SPONSOR_SLIDER_POSITION,
  ROOMS_NAVIGATION_STYLE,
  TIMEOUTS
};
